<template>
  <card type="plain"
        class="cost__card">
    <slot name="title">
      <h6 class="card-title">{{$t('job.create.costCalculator.title')}}</h6>
    </slot>
    <div v-if="!priceData">
      <img class="cost__img" src="/static/img/svg/cost.svg" alt="">
      <p class="card-description">
        {{$t('job.create.costCalculator.noData')}}
      </p>
    </div>
    <div v-if="priceData" v-loading="loading">
      <div v-for="product in priceData.products"
           class="price__row"
           :key="product.id">
        <div class="price__title">{{getJobBoard(product.job_board_id).name}}:</div>
        <div>{{product.price | toCurrency}}</div>
        <div v-if="isCreditPayment">{{Math.round(product.price/creditPrice)}} {{$t('generic.credits')}}</div>
        <div v-if="isContractPayment">
          <span>1 contract</span>
          <span :class="{'text-danger': isContractAmountSufficient(product.job_board_id)}">
            ({{getContract(product.job_board_id).amount}} available)
          </span>
        </div>
      </div>
      <div class="price__row--total">
        <div class="price__title--total">{{$t('job.create.costCalculator.total')}}</div>
        <div class="font-weight-bold">
          {{priceData.price | toCurrency}}
        </div>
        <div class="font-weight-bold" v-if="isCreditPayment">
          {{Math.round(priceData.price/creditPrice)}} {{$t('generic.credits')}}
        </div>
      </div>
      <div class="price__row--total" v-if="showAvailableCredits && isCreditPayment">
        <div class="price__title--total">{{$t('job.create.costCalculator.availableCredits')}}</div>
        <div :class="{'text-danger font-weight-bold': !hasEnoughCredits}">
          {{client.credits || 0}}
          <span>{{$t('generic.credits')}}</span>
        </div>
      </div>

    </div>
  </card>
</template>
<script>
  export default {
    props: {
      creditPrice: {
        type: Number,
        default: 1
      },
      priceData: {
        type: Object
      },
      getJobBoard: {
        type: Function,
        default: () => {}
      },
      client: {
        type: Object,
        default: () => ({})
      },
      payment: {
        type: Object,
        default: () => ({})
      },
      contractsBalance: {
        type: [Array, Object],
        default: () => []
      },
      loading: Boolean,
      showAvailableCredits: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        defaultContractPrice: 1,
        hasEnoughContracts: true
      }
    },
    computed: {
      totalPrice () {
        return this.priceData ? this.priceData.price : 0
      },
      totalPriceCredits () {
        if (!this.priceData) {
          return 0
        }
        return Math.round(this.priceData.price / this.creditPrice)
      },
      hasEnoughCredits() {
        let clientCredits = this.client.credits || 0;
        return this.totalPriceCredits <= clientCredits;
      },
      isCreditPayment () {
        return this.payment.type === 'credit'
      },
      isContractPayment () {
        return this.payment.type === 'contract'
      }
    },
    methods: {
      getContract(jobBoardId) {
        return this.contractsBalance.find(c => c.job_board_id === jobBoardId) || {amount: 0}
      },
      isContractAmountSufficient(jobBoardId){
        let amount = this.getContract(jobBoardId).amount
        this.hasEnoughContracts = this.defaultContractPrice <= amount
        this.$emit('cost-validated', this.hasEnoughContracts)
        return !this.hasEnoughContracts
      }
    },
    watch: {
      hasEnoughCredits(val){
        if (!this.isCreditPayment) {
          return
        }
        this.$emit('cost-validated', val)
      }
    }
  }
</script>
<style lang="scss" scoped>
  @import '~src/assets/sass/paper/variables';
  .cost__card {
    margin-top: 80px;
    padding: 10px;
  }

  .price__title--total,
  .price__title {
    min-width: 100px;
  }

  .price__row,
  .price__row--total {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;
  }

  .cost__img {
    height: 160px;
  }

  .price__row--total {
    border-top: 1px solid $medium-gray;
  }
</style>
